import {
  createConnection as publicCreateConnection,
  updateConnection as publicUpdateConnection,
  deleteConnection as publicDeleteConnection,
  enableConnection as publicEnableConnection,
  disableConnection as publicDisableConnection,
  getConnection as publicGetConnection,
  getEnabledConnection as publicGetEnabledConnection,
  listConnections as publicListConnections,
  listEnabledConnectionsClientData as publicListEnabledConnectionsClientData,
  bulkEnableConnections as publicBulkEnableConnections,
  bulkDisableConnections as publicBulkDisableConnections,
} from './iam-connection-v1-connection-connection.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onConnectionCreated as publicOnConnectionCreated } from './iam-connection-v1-connection-connection.public.js';
import { onConnectionDeleted as publicOnConnectionDeleted } from './iam-connection-v1-connection-connection.public.js';
import { onConnectionUpdated as publicOnConnectionUpdated } from './iam-connection-v1-connection-connection.public.js';

export const createConnection: MaybeContext<
  BuildRESTFunction<typeof publicCreateConnection> &
    typeof publicCreateConnection
> = /*#__PURE__*/ createRESTModule(publicCreateConnection);
export const updateConnection: MaybeContext<
  BuildRESTFunction<typeof publicUpdateConnection> &
    typeof publicUpdateConnection
> = /*#__PURE__*/ createRESTModule(publicUpdateConnection);
export const deleteConnection: MaybeContext<
  BuildRESTFunction<typeof publicDeleteConnection> &
    typeof publicDeleteConnection
> = /*#__PURE__*/ createRESTModule(publicDeleteConnection);
export const enableConnection: MaybeContext<
  BuildRESTFunction<typeof publicEnableConnection> &
    typeof publicEnableConnection
> = /*#__PURE__*/ createRESTModule(publicEnableConnection);
export const disableConnection: MaybeContext<
  BuildRESTFunction<typeof publicDisableConnection> &
    typeof publicDisableConnection
> = /*#__PURE__*/ createRESTModule(publicDisableConnection);
export const getConnection: MaybeContext<
  BuildRESTFunction<typeof publicGetConnection> & typeof publicGetConnection
> = /*#__PURE__*/ createRESTModule(publicGetConnection);
export const getEnabledConnection: MaybeContext<
  BuildRESTFunction<typeof publicGetEnabledConnection> &
    typeof publicGetEnabledConnection
> = /*#__PURE__*/ createRESTModule(publicGetEnabledConnection);
export const listConnections: MaybeContext<
  BuildRESTFunction<typeof publicListConnections> & typeof publicListConnections
> = /*#__PURE__*/ createRESTModule(publicListConnections);
export const listEnabledConnectionsClientData: MaybeContext<
  BuildRESTFunction<typeof publicListEnabledConnectionsClientData> &
    typeof publicListEnabledConnectionsClientData
> = /*#__PURE__*/ createRESTModule(publicListEnabledConnectionsClientData);
export const bulkEnableConnections: MaybeContext<
  BuildRESTFunction<typeof publicBulkEnableConnections> &
    typeof publicBulkEnableConnections
> = /*#__PURE__*/ createRESTModule(publicBulkEnableConnections);
export const bulkDisableConnections: MaybeContext<
  BuildRESTFunction<typeof publicBulkDisableConnections> &
    typeof publicBulkDisableConnections
> = /*#__PURE__*/ createRESTModule(publicBulkDisableConnections);
/** */
export const onConnectionCreated: BuildEventDefinition<
  typeof publicOnConnectionCreated
> &
  typeof publicOnConnectionCreated = /*#__PURE__*/ createEventModule(
  publicOnConnectionCreated
);
/** */
export const onConnectionDeleted: BuildEventDefinition<
  typeof publicOnConnectionDeleted
> &
  typeof publicOnConnectionDeleted = /*#__PURE__*/ createEventModule(
  publicOnConnectionDeleted
);
/** */
export const onConnectionUpdated: BuildEventDefinition<
  typeof publicOnConnectionUpdated
> &
  typeof publicOnConnectionUpdated = /*#__PURE__*/ createEventModule(
  publicOnConnectionUpdated
);

export {
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './iam-connection-v1-connection-connection.universal.js';
export {
  Connection,
  CreateConnectionRequest,
  CreateConnectionResponse,
  UpdateConnectionRequest,
  UpdateConnectionResponse,
  DeleteConnectionRequest,
  DeleteConnectionResponse,
  EnableConnectionRequest,
  EnableConnectionResponse,
  DisableConnectionRequest,
  DisableConnectionResponse,
  GetConnectionRequest,
  GetConnectionResponse,
  GetEnabledConnectionRequest,
  GetEnabledConnectionResponse,
  ListConnectionsRequest,
  CursorPaging,
  ListConnectionsResponse,
  ConnectionWithEnabled,
  CursorPagingMetadata,
  Cursors,
  ListEnabledConnectionsClientDataRequest,
  ListEnabledConnectionsClientDataResponse,
  ConnectionClientData,
  BulkEnableConnectionsRequest,
  BulkEnableConnectionsResponse,
  BulkEnabledConnectionPropertiesResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkDisableConnectionsRequest,
  BulkDisableConnectionsResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ConnectionCreatedEnvelope,
  ConnectionDeletedEnvelope,
  ConnectionUpdatedEnvelope,
  UpdateConnection,
  ListConnectionsOptions,
  ListEnabledConnectionsClientDataOptions,
  BulkEnableConnectionsOptions,
  BulkDisableConnectionsOptions,
} from './iam-connection-v1-connection-connection.universal.js';
export {
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './iam-connection-v1-connection-connection.universal.js';
